module.exports = __webpack_public_path__ + "static/media/talha-anis.f6672494.png";